import React from 'react';
import { ProductCard } from './ProductCard';
import { NoProductsFound } from './ProductFilters';
import type { Product, ProductVariant } from '../types/product';

interface ProductGridProps {
  products: Product[];
  onAddToCart: (variant: ProductVariant) => void;
  resetAllFilters: () => void;
}

export function ProductGrid({ products, onAddToCart, resetAllFilters }: ProductGridProps) {
  return (
    <div className="flex-1">
      {products.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-6">
          {products.map(product => (
            <ProductCard
              key={product.id}
              product={product}
              onAddToCart={onAddToCart}
            />
          ))}
        </div>
      ) : (
        <NoProductsFound resetAllFilters={resetAllFilters} />
      )}
    </div>
  );
}